// @flow weak

import _ from 'lodash/fp';
import {GET, POST, PUT} from '../helpers/request';
import {ADD as NOTIFICATION} from './notification';
import {STANDARD} from '../assortments';

export const GET_REQUEST = '@apartmentConfigView/GET_REQUEST';
export const GET_SUCCESS = '@apartmentConfigView/GET_SUCCESS';
export const GET_FAILURE = '@apartmentConfigView/GET_FAILURE';

export const UPDATE_REQUEST = '@apartmentConfigView/UPDATE_REQUEST';
export const UPDATE_SUCCESS = '@apartmentConfigView/UPDATE_SUCCESS';
export const UPDATE_FAILURE = '@apartmentConfigView/UPDATE_FAILURE';

export const CREATE_REQUEST = '@apartmentConfigView/CREATE_REQUEST';
export const CREATE_SUCCESS = '@apartmentConfigView/CREATE_SUCCESS';
export const CREATE_FAILURE = '@apartmentConfigView/CREATE_FAILURE';

export const ROOM_UPDATE_REQUEST = '@apartmentConfigView/ROOM_UPDATE_REQUEST';
export const ROOM_UPDATE_SUCCESS = '@apartmentConfigView/ROOM_UPDATE_SUCCESS';
export const ROOM_UPDATE_FAILURE = '@apartmentConfigView/ROOM_UPDATE_FAILURE';

export const ROOM_CREATE_REQUEST = '@apartmentConfigView/ROOM_CREATE_REQUEST';
export const ROOM_CREATE_SUCCESS = '@apartmentConfigView/ROOM_CREATE_SUCCESS';
export const ROOM_CREATE_FAILURE = '@apartmentConfigView/ROOM_CREATE_FAILURE';

export const PRODUCT_SLOT_UPDATE_REQUEST = '@apartmentConfigView/PRODUCT_SLOT_UPDATE_REQUEST';
export const PRODUCT_SLOT_UPDATE_SUCCESS = '@apartmentConfigView/PRODUCT_SLOT_UPDATE_SUCCESS';
export const PRODUCT_SLOT_UPDATE_FAILURE = '@apartmentConfigView/PRODUCT_SLOT_UPDATE_FAILURE';

export const PRODUCT_SLOT_CREATE_REQUEST = '@apartmentConfigView/PRODUCT_SLOT_CREATE_REQUEST';
export const PRODUCT_SLOT_CREATE_SUCCESS = '@apartmentConfigView/PRODUCT_SLOT_CREATE_SUCCESS';
export const PRODUCT_SLOT_CREATE_FAILURE = '@apartmentConfigView/PRODUCT_SLOT_CREATE_FAILURE';

export const SELECT_ROOM = '@apartmentConfigView/SELECT_ROOM';
export const SELECT_PRODUCT_SLOT = '@apartmentConfigView/SELECT_PRODUCT_SLOT';
export const RESET = '@apartmentConfigView/RESET';
export const CLEAR = '@apartmentConfigView/CLEAR';

export const OPEN_DIALOG_REQUEST = '@apartmentConfigView/OPEN_DIALOG_REQUEST';
export const OPEN_DIALOG_FAILURE = '@apartmentConfigView/OPEN_DIALOG_FAILURE';
export const OPEN_DIALOG_SUCCESS = '@apartmentConfigView/OPEN_DIALOG_SUCCESS';
export const CLOSE_DIALOG = '@apartmentConfigView/CLOSE_DIALOG';
export const POP_DIALOG_NAVIGATION = '@apartmentConfigView/POP_DIALOG_NAVIGATION';
export const NAVIGATE_TO_VARIANT_REQUEST = '@apartmentConfigView/NAVIGATE_TO_VARIANT_REQUEST';
export const NAVIGATE_TO_VARIANT_FAILURE = '@apartmentConfigView/NAVIGATE_TO_VARIANT_FAILURE';
export const NAVIGATE_TO_VARIANT_SUCCESS = '@apartmentConfigView/NAVIGATE_TO_VARIANT_SUCCESS';
export const UPDATE_RELATED_VARIANT = '@apartmentConfigView/UPDATE_RELATED_VARIANT';
export const TOGGLE_VARIANT_REQUEST = '@apartmentConfigView/TOGGLE_VARIANT_REQUEST';
export const TOGGLE_VARIANT_FAILURE = '@apartmentConfigView/TOGGLE_VARIANT_FAILURE';
export const TOGGLE_VARIANT_SUCCESS = '@apartmentConfigView/TOGGLE_VARIANT_SUCCESS';
export const SET_STANDARD_PRODUCT = '@apartmentConfigView/SET_STANDARD_PRODUCT';
export const TOGGLE_PRODUCT = '@apartmentConfigView/TOGGLE_PRODUCT';
export const CHECK_ALL_VARIANTS = '@apartmentConfigView/CHECK_ALL_VARIANTS';
export const CLEAR_STANDARD_PRODUCT = '@apartmentConfigView/CLEAR_STANDARD_PRODUCT';
export const CHECK_PRODUCT = '@apartmentConfigView/CHECK_PRODUCT';
export const UPDATE_VARIANTS = '@apartmentConfigView/UPDATE_VARIANTS';
export const ROOMS_UPDATE_REQUEST = '@apartmentConfigView/ROOMS_UPDATE_REQUEST';
export const ROOMS_UPDATE_FAILURE = '@apartmentConfigView/ROOMS_UPDATE_FAILURE';
export const ROOMS_UPDATE_SUCCESS = '@apartmentConfigView/ROOMS_UPDATE_SUCCESS';
export const PRODUCT_SLOTS_UPDATE_REQUEST = '@apartmentConfigView/PRODUCT_SLOTS_UPDATE_REQUEST';
export const PRODUCT_SLOTS_UPDATE_FAILURE = '@apartmentConfigView/PRODUCT_SLOTS_UPDATE_FAILURE';
export const PRODUCT_SLOTS_UPDATE_SUCCESS = '@apartmentConfigView/PRODUCT_SLOTS_UPDATE_SUCCESS';
export const UPDATE_VARIANTS_FOR_TYPE = '@apartmentConfigView/UPDATE_VARIANTS_FOR_TYPE';

const roomsUpdateRequest = () => ({
  type: ROOMS_UPDATE_REQUEST,
});

const roomsUpdateFailure = error => ({
  type: ROOMS_UPDATE_FAILURE,
  error,
});

const roomsUpdateSuccess = rooms => ({
  type: ROOMS_UPDATE_SUCCESS,
  rooms,
});

const productSlotsUpdateRequest = () => ({
  type: PRODUCT_SLOTS_UPDATE_REQUEST,
});

const productSlotsUpdateFailure = error => ({
  type: PRODUCT_SLOTS_UPDATE_FAILURE,
  error,
});

const productSlotsUpdateSuccess = (roomId, productSlotId, productSlots) => ({
  type: PRODUCT_SLOTS_UPDATE_SUCCESS,
  roomId,
  productSlotId,
  productSlots,
});

export const updateVariants = (productId: number, data: any) => ({
  type: UPDATE_VARIANTS,
  productId,
  data,
});

export const updateVariantsForType = (productTypeId: number, data: any) => ({
  type: UPDATE_VARIANTS_FOR_TYPE,
  productTypeId,
  data,
});

export const checkProduct = (productId: number, checked: boolean) => ({
  type: CHECK_PRODUCT,
  productId,
  checked,
});

export const checkAllVariants = checked => ({
  type: CHECK_ALL_VARIANTS,
  checked,
});

export const toggleProduct = product => ({
  type: TOGGLE_PRODUCT,
  product,
});

export const popDialogNavigation = depth => ({
  type: POP_DIALOG_NAVIGATION,
  depth,
});

const navigateToVariantRequest = () => ({
  type: NAVIGATE_TO_VARIANT_REQUEST,
});

const navigateToVariantFailure = error => ({
  type: NAVIGATE_TO_VARIANT_FAILURE,
  error,
});

const navigateToVariantSuccess = variant => ({
  type: NAVIGATE_TO_VARIANT_SUCCESS,
  variant,
});

export const navigateToVariant = variant => async dispatch => {
  dispatch(navigateToVariantRequest());
  try {
    const fullVariant = await GET({endpoint: `/productvariants/${variant.id}`}, dispatch);
    dispatch(navigateToVariantSuccess({
      ...fullVariant,
      uuid: variant.uuid,
    }));
  } catch (err) {
    dispatch(navigateToVariantFailure(err));
  }
};

export const updateRelatedVariant = (variant, data) => ({
  type: UPDATE_RELATED_VARIANT,
  variant,
  data,
});

export const setStandardProduct = (product, productType) => ({
  type: SET_STANDARD_PRODUCT,
  product,
  productType,
});

export const clearStandardProduct = productType => ({
  type: CLEAR_STANDARD_PRODUCT,
  productType,
});

const toggleVariantRequest = () => ({
  type: TOGGLE_VARIANT_REQUEST,
});

const toggleVariantFailure = error => ({
  type: TOGGLE_VARIANT_FAILURE,
  error,
});

const toggleVariantSuccess = (variant, expand) => ({
  type: TOGGLE_VARIANT_SUCCESS,
  variant,
  expand,
});

export const toggleVariant = (variant, expand) => async dispatch => {
  if (expand) {
    dispatch(toggleVariantRequest());
    try {
      const fullVariant = await GET({endpoint: `/productvariants/${variant.id}`}, dispatch);
      dispatch(toggleVariantSuccess({
        ...fullVariant,
        uuid: variant.uuid,
      }, expand));
    } catch (err) {
      dispatch(toggleVariantFailure(err));
    }
  } else {
    dispatch(toggleVariantSuccess(variant, expand));
  }
};

const openDialogRequest = () => ({
  type: OPEN_DIALOG_REQUEST,
});

const openDialogFailure = error => ({
  type: OPEN_DIALOG_FAILURE,
  error,
});

const openDialogSuccess = (products, rootName, productType) => ({
  type: OPEN_DIALOG_SUCCESS,
  products,
  rootName,
  productType,
});

export const openDialog = (productTypeId, rootName) => async dispatch => {
  dispatch(openDialogRequest());
  try {
    const productType = await GET({endpoint: `/producttypes/${productTypeId}`}, dispatch);
    const products = await GET({endpoint: `/products?productTypeId=${productTypeId}&assortment=${STANDARD}`}, dispatch);
    dispatch(openDialogSuccess(products, rootName, productType));
  } catch (err) {
    dispatch(openDialogFailure(err));
  }
};

export const closeDialog = () => ({
  type: CLOSE_DIALOG,
});

const dataRequest = () => ({
  type: GET_REQUEST,
});

const dataSuccess = (apartmentConfig, project, roomTypes, products, productTypes, apartmentConfigs, configTemplates, roomTemplates, projects) => ({
  type: GET_SUCCESS,
  apartmentConfig,
  project,
  roomTypes,
  products,
  productTypes,
  apartmentConfigs,
  configTemplates,
  roomTemplates,
  projects,
});

const dataFailure = error => ({
  type: GET_FAILURE,
  error,
});

const apartmentConfigUpdateRequest = () => ({
  type: UPDATE_REQUEST,
});

const apartmentConfigUpdateSuccess = apartmentConfig => ({
  type: UPDATE_SUCCESS,
  apartmentConfig,
  [NOTIFICATION]: {
    message: 'Lägenhetskonfiguration uppdaterad',
  },
});

const apartmentConfigUpdateFailure = error => ({
  type: UPDATE_FAILURE,
  error,
});

const apartmentConfigCreateRequest = () => ({
  type: CREATE_REQUEST,
});

const apartmentConfigCreateSuccess = apartmentConfig => ({
  type: CREATE_SUCCESS,
  apartmentConfig,
  [NOTIFICATION]: {
    message: `Lägenhetskonfiguration "${apartmentConfig.name}" skapad`,
  },
});

const apartmentConfigCreateFailure = error => ({
  type: CREATE_FAILURE,
  error,
});

const roomUpdateRequest = () => ({
  type: ROOM_UPDATE_REQUEST,
});

const roomUpdateSuccess = room => ({
  type: ROOM_UPDATE_SUCCESS,
  room,
  [NOTIFICATION]: {
    message: 'Rum uppdaterat',
  },
});

const roomUpdateFailure = error => ({
  type: ROOM_UPDATE_FAILURE,
  error,
});

const roomCreateRequest = () => ({
  type: ROOM_CREATE_REQUEST,
});

const roomCreateSuccess = room => ({
  type: ROOM_CREATE_SUCCESS,
  room,
  [NOTIFICATION]: {
    message: `Rum "${room.name}" skapat`,
  },
});

const roomCreateFailure = error => ({
  type: ROOM_CREATE_FAILURE,
  error,
});

const productSlotUpdateRequest = () => ({
  type: PRODUCT_SLOT_UPDATE_REQUEST,
});

const productSlotUpdateSuccess = productSlot => ({
  type: PRODUCT_SLOT_UPDATE_SUCCESS,
  productSlot,
  [NOTIFICATION]: {
    message: 'Produktplats uppdaterad',
  },
});

const productSlotUpdateFailure = error => ({
  type: PRODUCT_SLOT_UPDATE_FAILURE,
  error,
});

const productSlotCreateRequest = () => ({
  type: PRODUCT_SLOT_CREATE_REQUEST,
});

const productSlotCreateSuccess = (productSlot, roomId) => ({
  type: PRODUCT_SLOT_CREATE_SUCCESS,
  productSlot,
  roomId,
  [NOTIFICATION]: {
    message: `Produktplats "${productSlot.name}" skapad`,
  },
});

const productSlotCreateFailure = error => ({
  type: PRODUCT_SLOT_CREATE_FAILURE,
  error,
});

export const clear = () => ({
  type: CLEAR,
});

export const reset = () => ({
  type: RESET,
});

export const selectRoom = room => ({
  type: SELECT_ROOM,
  room,
});

export const selectProductSlot = (roomId, productSlot) => ({
  type: SELECT_PRODUCT_SLOT,
  roomId,
  productSlot,
});

export const sortByName =
  _.sortBy([x => _.toLower(x.name)]);

export const filterAndSort = _.flow(
  _.filter({archived: null}),
  sortByName,
);

export const fetchData = (id, projectId) => async dispatch => {
  dispatch(dataRequest());
  try {
    const roomTypes = sortByName(await GET({endpoint: '/roomtypes'}, dispatch));
    const products = await GET({endpoint: `/products?assortment=${STANDARD}`}, dispatch);
    const productTypes = sortByName(await GET({endpoint: '/producttypes'}, dispatch));
    const roomTemplates = filterAndSort(await GET({endpoint: '/roomtemplates'}, dispatch));
    const projects = sortByName(_.map(x => ({
      ...x,
      apartmentConfigs: sortByName(x.apartmentConfigs),
    }), await GET({endpoint: '/projects/rooms'}, dispatch)));
    let apartmentConfig, project;
    let apartmentConfigs = [];
    let configTemplates = [];
    if (id) {
      apartmentConfig = await GET({endpoint: `/apartmentconfigs/${id}`}, dispatch);
      project = await GET({endpoint: `/projects/${apartmentConfig.projectId}`}, dispatch);
    } else if (projectId) {
      project = await GET({endpoint: `/projects/${projectId}`}, dispatch);
      apartmentConfigs = filterAndSort(await GET({endpoint: `/projects/${projectId}/apartmentconfigs`}, dispatch));
      configTemplates = filterAndSort(await GET({endpoint: '/configtemplates'}, dispatch));
    }
    dispatch(dataSuccess(apartmentConfig, project, roomTypes, products, productTypes, apartmentConfigs, configTemplates, roomTemplates, projects));
  } catch (err) {
    dispatch(dataFailure(err));
  }
};

export const updateApartmentConfig = (id, body) => async dispatch => {
  dispatch(apartmentConfigUpdateRequest());
  try {
    const apartmentConfig = await PUT({
      endpoint: `/apartmentconfigs/${id}`,
      body,
    }, dispatch);
    dispatch(apartmentConfigUpdateSuccess(apartmentConfig));
  } catch (err) {
    dispatch(apartmentConfigUpdateFailure(err));
  }
};

export const createApartmentConfig = (projectId, body) => async dispatch => {
  dispatch(apartmentConfigCreateRequest());
  try {
    const apartmentConfig = await POST({
      endpoint: `/projects/${projectId}/apartmentconfigs`,
      body,
    }, dispatch);
    dispatch(apartmentConfigCreateSuccess(apartmentConfig));
  } catch (err) {
    dispatch(apartmentConfigCreateFailure(err));
  }
};

export const createRoom = (configId, body) => async dispatch => {
  dispatch(roomCreateRequest());
  try {
    const room = await POST({
      endpoint: `/apartmentconfigs/${configId}/rooms`,
      body,
    }, dispatch);
    dispatch(roomCreateSuccess(room));
  } catch (err) {
    dispatch(roomCreateFailure(err));
  }
};

export const updateRoom = (id, body) => async dispatch => {
  dispatch(roomUpdateRequest());
  try {
    const room = await PUT({
      endpoint: `/rooms/${id}`,
      body,
    }, dispatch);
    dispatch(roomUpdateSuccess(room));
  } catch (err) {
    dispatch(roomUpdateFailure(err));
  }
};

export const createProductSlot = (roomId, body) => async dispatch => {
  dispatch(productSlotCreateRequest());
  try {
    const productslot = await POST({
      endpoint: `/rooms/${roomId}/productslots`,
      body,
    }, dispatch);
    dispatch(productSlotCreateSuccess(productslot, roomId));
  } catch (err) {
    dispatch(productSlotCreateFailure(err));
  }
};

export const updateProductSlot = (id, body) => async dispatch => {
  dispatch(productSlotUpdateRequest());
  try {
    const productslot = await PUT({
      endpoint: `/productslots/${id}`,
      body,
    }, dispatch);
    dispatch(productSlotUpdateSuccess(productslot));
  } catch (err) {
    dispatch(productSlotUpdateFailure(err));
  }
};

export const updateRooms = (apartmentConfigId, roomId, sortDirection: 'up' | 'down') => async dispatch => {
  dispatch(roomsUpdateRequest());
  try {
    const rooms = await PUT({
      endpoint: `/apartmentconfigs/${apartmentConfigId}/rooms`,
      body: {
        roomId,
        sortDirection,
      },
    }, dispatch);
    dispatch(roomsUpdateSuccess(rooms));
  } catch (err) {
    dispatch(roomsUpdateFailure(err));
  }
};

export const updateProductSlots = (roomId, productSlotId, sortDirection: 'up' | 'down') => async dispatch => {
  dispatch(productSlotsUpdateRequest());
  try {
    const productSlots = await PUT({
      endpoint: `/rooms/${roomId}/productslots`,
      body: {
        productSlotId,
        sortDirection,
      },
    }, dispatch);
    dispatch(productSlotsUpdateSuccess(roomId, productSlotId, productSlots));
  } catch (err) {
    dispatch(productSlotsUpdateFailure(err));
  }
};



// WEBPACK FOOTER //
// ./src/actions/apartmentConfigView.js